export const AUTH_THEME = 'dark';

const AUTH_ROUTE_PREFIXES = ['/sign-in', '/sign-up'];

export const isAuthRoute = (pathname) =>
  AUTH_ROUTE_PREFIXES.some((prefix) => pathname === prefix || pathname.startsWith(`${prefix}/`));

export const authColors = {
  colorBackground: '#151a36',
  colorForeground: '#f8fafc',
  colorMutedForeground: '#cbd5e1',
  colorPrimary: '#38bdf8',
  colorPrimaryForeground: '#0b1120',
  colorInput: '#1e2548',
  colorInputForeground: '#f8fafc',
  colorNeutral: '#ffffff',
  colorDanger: '#f87171',
  colorSuccess: '#34d399',
  colorWarning: '#fbbf24',
};

export const appLightColors = {
  colorBackground: '#ffffff',
  colorForeground: '#111827',
  colorMutedForeground: '#4b5563',
  colorPrimary: '#0369a1',
  colorPrimaryForeground: '#ffffff',
  colorInput: '#ffffff',
  colorInputForeground: '#111827',
  colorNeutral: '#000000',
  colorDanger: '#dc2626',
  colorSuccess: '#047857',
  colorWarning: '#b45309',
};

export const appDarkColors = authColors;

export const authPlaceholderColor = '#94a3b8';

export const AUTH_CARD_OPACITY = 0.75;

export const brandButtonGradientStops = ['#0e7490', '#2563eb', '#9333ea'];

const typography = {
  fontFamily: "'Inter Variable', 'Inter', sans-serif",
  fontFamilyButtons: "'Inter Variable', 'Inter', sans-serif",
  fontSize: '0.875rem',
};

const sharedElements = {
  cardBox: '!rounded-squircle',
  formButtonPrimary:
    '!bg-gradient-primary-strong !text-white !border-0 !shadow-soft hover:!shadow-glow focus-visible:!ring-2 focus-visible:!ring-primary-400',
};

export const authAppearance = {
  variables: {
    ...authColors,
    ...typography,
    borderRadius: '0.75rem',
  },
  elements: {
    ...sharedElements,
    rootBox: 'mx-auto w-full',
    cardBox: `${sharedElements.cardBox} w-full !bg-[#151a36]/75 backdrop-blur-xl border border-white/10 !shadow-glow-card`,
    card: '!bg-transparent !shadow-none',
    footer: '!bg-none !bg-transparent',
    formFieldInput: 'placeholder:text-slate-400 focus:!ring-2 focus:!ring-sky-400/60',
    socialButtonsBlockButton: '!bg-white/5 hover:!bg-white/10 !border-white/15',
  },
};

const appAppearance = (colors) => ({
  variables: {
    ...colors,
    ...typography,
    borderRadius: '0.75rem',
  },
  elements: {
    ...sharedElements,
    userButtonPopoverCard: '!rounded-squircle !shadow-soft-lg',
  },
});

export const appClerkAppearance = {
  light: appAppearance(appLightColors),
  dark: appAppearance(appDarkColors),
};
